import { Component } from '@angular/core';
import { DynamicDialog } from './dynamic-dialog';
import { DynamicDialogComponent } from './dynamic-dialog.component';

@Component({
  imports: [DynamicDialogComponent],
  template: `
    <ct-dynamic-dialog title="Daten für Training verwenden">
      <p>
        Bist du sicher, dass die erfassten Daten für das Training verwendet werden sollen? Bitte
        dies nur bestätigen, wenn Du sicher bist, dass die Daten, die du erfasst hast korrekt sind.
      </p>
    </ct-dynamic-dialog>
  `,
})
export class ConfirmUseExtractedDataForTrainingDialogComponent implements DynamicDialog<boolean> {}
